module.exports = __webpack_public_path__ + "static/media/bg-desktop.fd695998.jpg";